module.exports = __webpack_public_path__ + "static/media/celine_sung.a5ce8094.png";